import React from 'react';
import DocumentReader from './DocumentReader';
import { documentTitle, documentSlug, parts } from './content/strategies';

export default function TestStrategies() {
  return (
    <DocumentReader
      documentId={documentSlug}
      title={documentTitle}
      intro="What to do when you're not sure of an answer, and how to structure your studying across every domain on the test."
      parts={parts}
    />
  );
}
